import React, { useContext } from 'react';
import { Title } from '@investoro/core';
import styled from 'styled-components';
import { PropertyValuationContext } from 'utils/context/PropertyValuationContext';

import { TimeRangeAverageMeterAndTotalPrice } from 'components/analysis/components/TimeRangeAverageMeterAndTotalPrice';

const Container = styled.div`
    width: 100%;
    background-color: var(--color-white);
    border-radius: 16px;
    margin-bottom: 20px;
    padding: 50px;

    @media (max-width: 1100px) {
        padding: 20px 20px 0px;
    }
`;

const ValuationAnalysis = () => {
    const { valuationState } = useContext(PropertyValuationContext);
    const { valuationAnalysis } = valuationState;

    const averagePriceAreaByTime = valuationAnalysis?.analysisTimeRows?.map((x) => ({
        name: x.timeRangeLabel.replace('100-∞', '100+').replace('-', ' - '),
        line: x.avgPrice,
        bar: x.avgPricePerSquareMeter
    }))?.slice(0, -1) || [];

    if (!averagePriceAreaByTime.length) {
        return null;
    }

    return (
        <Container>
            <Title>Anliza graficzna</Title>
            <TimeRangeAverageMeterAndTotalPrice averagePriceAreaByTime={averagePriceAreaByTime} />
        </Container>
    );
};

export default ValuationAnalysis;
